module.exports = __webpack_public_path__ + "img/Prishtina.4397135f.png";